"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _base = require("@atlaskit/icon/base");
var _maximize = _interopRequireDefault(require("@atlaskit/icon/core/maximize"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const ImageResizeIcon = props => /*#__PURE__*/_react.default.createElement(_base.IconFacade, Object.assign({
  dangerouslySetGlyph: `<svg width="24" height="24" viewBox="0 0 24 24" role="presentation"><g fill-rule="evenodd"><rect width="18" height="18" x="3" y="3" fill="currentcolor" rx="2"/><path fill="inherit" d="M5 14v3.89a1.1 1.1 0 0 0 1.1 1.1H10a1 1 0 1 0 0-2H7V14a1 1 0 1 0-2 0"/><path fill="inherit" d="M5.707 18.121c.39.39 1.027.388 1.41.004L18.125 7.117a.995.995 0 0 0-.004-1.41 1 1 0 0 0-1.41-.004L5.703 16.711a.995.995 0 0 0 .004 1.41"/><path fill="inherit" d="M17 7v2.99a1 1 0 0 0 2 0V6.1A1.1 1.1 0 0 0 17.9 5H14a1 1 0 0 0 0 2z"/></g></svg>`
}, props, {
  newIcon: _maximize.default
}));
ImageResizeIcon.displayName = 'ImageResizeIcon';
var _default = exports.default = ImageResizeIcon;